import React from 'react';
// import logo from './logo.svg';
import './App.css';
import Schedule from './schedule/Schedule';

function App() {
  return (
    <Schedule />
  );
}

export default App;
